<template>
  <base-dropdown position="right" class="nav-link pr-0">
    <base-button ref="userBtn" slot="title" class="btn-custom white-btn-custom dropdown-toggle mr-0">
      <v-gravatar width="30" height="30" class="rounded-circle" :hash="$keycloak.userName" alt="User icon" :size="30" default-img="identicon" />
    </base-button>
    <template>
      <div class=" dropdown-header noti-title">
        <h6 class="text-overflow m-0">{{ $t('welcome') }}!</h6>
      </div>
      <div class="dropdown-item-text dropdown-text-padding">
        <span class="m-0">{{ $keycloak.userName }}</span>
      </div>
      <div class="dropdown-divider"></div>
      <!-- <div class="dropdown-item d-flex" @click="$keycloak.logoutFn"> -->
      <div class="dropdown-item d-flex" @click="logout">
        <div class="mr-1"><img width="20" height="20" src="/static/img/icons/logout.svg" alt="logout icon"></div>
        <div><span>{{ $t('log_out') }}</span></div>
      </div>
    </template>
  </base-dropdown>
</template>

<script>
export default {
  name: 'UserInfoDropdown',
  methods: {
    logout() {
      let url = this.$keycloak.createLogoutUrl()
      url = url.replaceAll('redirect_uri', 'post_logout_redirect_uri')
      url = `${url}&client_id=${this.$keycloak.keycloak.clientId}`
      window.location.href = url
    }
  }
}
</script>
<style scoped>
  .btn-custom {
    padding: 5px 10px !important;
  }
  /deep/ .dropdown-text-padding {
    padding: .5rem 1rem !important;
  }
  .white-btn-custom {
    background-color: inherit !important;
    box-shadow: none !important;
    border: none !important;
  }
  .white-btn-custom:hover {
    background-color: #fff !important;
  }
  .white-btn-custom:active {
    background-color: #fff !important;
  }
  /deep/.white-btn-custom:hover.dropdown-toggle::after,
  /deep/.white-btn-custom:active.dropdown-toggle::after {
    color: #000 !important;
  }
  @media only screen and (max-width: 767px) {
    /deep/.white-btn-custom::after,
    /deep/.white-btn-custom::after {
      color: #000 !important;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/UserInfoDropdown.vue